<template>
  <div>
    Déconnexion en cours
  </div>
</template>

<script>
export default {
  name: 'Logout',
  props: {
  },
  methods: {
  },
  mounted() {
    if (window.localStorage.getItem('pseudo') || window.localStorage.getItem('token')) {
      window.localStorage.removeItem('pseudo');
      window.localStorage.removeItem('token');

      const redirectUrl = this.$route.query && this.$route && this.$route.query.redirectUrl ? this.$route.query.redirectUrl : 'http://google.com';
      window.location = redirectUrl;
    }
  }
}
</script>

<style scoped>
</style>
